/* @flow */

import React from 'react';
import { Grid, Message, Icon, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const NoPages = () => (
  <Segment>
    <Grid centered columns={3}>
      <Grid.Column>
        <Message icon attached>
          <Icon name="home" />
          <Message.Content>
            <Message.Header>
              Aucune page d'accueil dans le catalogue
            </Message.Header>
          </Message.Content>
        </Message>
        <Segment attached="bottom">
          <Link
            to={{ pathname: '/pages/new', query: { root: true } }}
            className="ui fluid primary button"
          >
            Créer une page d'accueil
          </Link>
        </Segment>
      </Grid.Column>
    </Grid>
  </Segment>
);

export default NoPages;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Pages/components/NoPages.js